import { create } from 'zustand';
import { api } from './api.js';

export const useAuthStore = create((set, get) => ({
  user: null,
  company: null,
  roles: [],
  groupMemberships: [],
  loading: true,
  error: null,

  loadMe: async () => {
    try {
      const data = await api.me();
      set({ user: data.user, company: data.company, roles: data.roles, groupMemberships: data.group_memberships, loading: false });
    } catch (err) {
      set({ user: null, company: null, roles: [], loading: false });
    }
  },

  login: async (email, password, totp_code) => {
    set({ error: null });
    const body = { email, password };
    if (totp_code) body.totp_code = totp_code;
    await api.login(body);
    await get().loadMe();
  },

  signup: async (data) => {
    set({ error: null });
    await api.signup(data);
    await get().loadMe();
  },

  logout: async () => {
    try { await api.logout(); } catch {}
    set({ user: null, company: null, roles: [], groupMemberships: [] });
  },

  hasRole: (role) => get().roles.some(r => r.role === role),
  isSuperUser: () => get().roles.some(r => r.role === 'super_user'),
  isGroupAdmin: () => get().roles.some(r => r.role === 'group_admin')
}));

export const useToast = create((set) => ({
  toasts: [],
  push: (toast) => {
    const id = Math.random().toString(36).slice(2);
    set(s => ({ toasts: [...s.toasts, { id, ...toast }] }));
    setTimeout(() => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })), toast.duration || 4000);
  },
  remove: (id) => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }))
}));
